// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aK3R","title":"styles_title__2ZZmR"};